export default __webpack_public_path__ + "static/media/img1_plus.91b623a3.jpg";